import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import "./fontAwesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-toastify/dist/ReactToastify.css";
import Home from "./components/home";
import ProtectedRoute from "./components/common/protectedRoute";
import LoginForm from "./components/loginForm";
import RegisterForm from "./components/registerForm";
import Logout from "./components/logout";
import SearchContainer from "./components/searchContainer";
import AircraftResults from "./components/aircraftResults";
import ManufacturerResults from "./components/manufacturers/manufacturerResults";
import AircraftDetails from "./components/aircraftDetails";
import ImageWikiForm from "./components/imageWikiForm";
import AircraftForm from "./components/aircraftForm";
import SupportForm from "./components/supportForm";
import Models from "./components/models";
import Manufacturers from "./components/manufacturers/manufacturers";
import ManufacturerDetails from "./components/manufacturers/manufacturerDetails";
import AddBrandImage from "./components/manufacturers/addBrandImage";
import SponsorForm from "./components/sponsors/sponsorForm";
import SponsorsList from "./components/sponsors/sponsorsList";
import SuccessPage from "./components/successPage";
import SupportIssues from "./components/supportIssues";
import SupportIssueDetail from "./components/supportIssueDetail";
import TestComp from "./components/test";
import { getCurrentUser } from "./services/authService";
import NavBar from "./components/common/navbar";
import airplaneIcon from "../src/images/airplaneIcon4.png";

class App extends Component {
	state = {};

	componentDidMount() {
		const user = getCurrentUser();
		this.setState({ user });
	}

	render() {
		const { user } = this.state;

		return (
			<React.Fragment>
				<ToastContainer />
				<div className="red-bar"></div>
				<div className="App-header">
					<img
						src={airplaneIcon}
						alt="airplanceIcon"
						className="airplane-icon"
					/>
					<span className="app_title">
						Aircraft Modelling for WWII&nbsp;&nbsp;
						<FontAwesomeIcon icon="globe-americas" className="globe-icon" />
					</span>
				</div>
				<NavBar user={user} />
				<main className="container" style={{ textAlign: "left" }}>
					<Switch>
						<Route path="/" exact={true} component={Home} />
						<Route path="/contact-us" component={SupportForm} />
						<Route path="/success" component={SuccessPage} />
						<Route path="/login" component={LoginForm} />
						<Route path="/logout" component={Logout} />
						<ProtectedRoute path="/register" component={RegisterForm} />
						<ProtectedRoute path="/search" component={SearchContainer} />
						<ProtectedRoute
							path="/aircraft/results"
							component={AircraftResults}
						/>
						<ProtectedRoute
							path="/manufacturer/results"
							component={ManufacturerResults}
						/>
						<ProtectedRoute
							path="/imagewiki/:aircraft_id"
							component={ImageWikiForm}
						/>
						<ProtectedRoute
							path="/aircraft/details/:aircraft_id"
							component={AircraftDetails}
						/>
						<ProtectedRoute path="/aircraft/add" component={AircraftForm} />
						<ProtectedRoute
							path="/aircraft/edit/:aircraft_id"
							component={AircraftForm}
						/>
						<ProtectedRoute
							path="/manufacturer/add"
							component={Manufacturers}
						/>
						<ProtectedRoute
							path="/manufacturer/edit/:manufacturer_id"
							component={Manufacturers}
						/>
						<ProtectedRoute
							path="/manufacturer/details/:manufacturer_id"
							component={ManufacturerDetails}
						/>
						<ProtectedRoute
							path="/brand/logo/:manufacturer_id"
							component={AddBrandImage}
						/>
						<ProtectedRoute path="/models" component={Models} />
						<ProtectedRoute path="/sponsor/add" component={SponsorForm} />
						<ProtectedRoute path="/sponsor/edit" component={SponsorForm} />
						<ProtectedRoute path="/sponsors/list" component={SponsorsList} />
						<ProtectedRoute path="/issues" component={SupportIssues} />
						<ProtectedRoute
							path="/issue/detail"
							component={SupportIssueDetail}
						/>
						<Route path="/test" component={TestComp} />
					</Switch>
				</main>
				<footer>(c) copyright 2023</footer>
			</React.Fragment>
		);
	}
}

export default withRouter(App);
